/**
 * Raw blog post metadata.
 *
 * This file contains only the post data with no SvelteKit dependencies,
 * allowing it to be imported by build scripts (like RSS generation).
 *
 * Each post should have a corresponding markdown file at:
 * src/routes/news/[slug]/+page.md
 */

export interface PostMeta {
  slug: string;
  title: string;
  description: string;
  date: string;
  author: string;
  image?: string;
  tags: string[];
  featured?: boolean;
  /** Set to true to hide from production builds */
  draft?: boolean;
}

export const posts: PostMeta[] = [
  {
    slug: 'introducing-corral-ai',
    title: 'Introducing Corral AI: Enterprise AI in Your Cloud',
    description:
      'Today we announce Corral AI, a new approach to enterprise AI that deploys directly into your Azure tenant. Your data stays yours, fully managed by us, fully controlled by you.',
    date: '2025-12-15',
    author: 'Corral Team',
    tags: ['Announcement', 'Product'],
    featured: true
  },
  {
    slug: 'azure-marketplace-launch',
    title: 'Corral AI Now Available on Azure Marketplace',
    description:
      'Deploy Corral AI directly from the Azure Marketplace with one click. Get started in minutes with enterprise-grade AI that respects your security boundaries.',
    date: '2024-12-10',
    author: 'Corral Team',
    tags: ['Azure', 'Launch'],
    featured: false,
    draft: true
  },
  {
    slug: 'zero-trust-ai-architecture',
    title: 'Building Zero-Trust AI: Our Architecture Philosophy',
    description:
      'A deep dive into how we designed Corral to operate without ever accessing your data. Learn about our zero-trust architecture and why it matters for enterprise AI.',
    date: '2024-12-05',
    author: 'Engineering Team',
    tags: ['Engineering', 'Security'],
    featured: false,
    draft: true
  },
  {
    slug: 'design-partner-program',
    title: 'Join Our Design Partner Program',
    description:
      'We are looking for forward-thinking enterprises to help shape the future of secure AI deployment. Early partners get direct access to our team and influence our roadmap.',
    date: '2024-11-28',
    author: 'Corral Team',
    tags: ['Partners', 'Program'],
    featured: false,
    draft: true
  },
  {
    slug: 'upcoming-features-preview',
    title: 'Upcoming Features Preview: What We Are Building',
    description:
      'A sneak peek at the features coming to Corral in Q1 2025. This is a draft post visible only in development environments.',
    date: '2025-01-15',
    author: 'Product Team',
    tags: ['Roadmap', 'Preview'],
    featured: false,
    draft: true
  }
];
